import { Transition } from "components/shared/column";
import { sectionTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React, { useEffect, useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { Link } from "react-router-dom";
import { index as reportsList } from "sources/books/reports";
import connect from "./container";

function ReportsList(props) {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);
    useEffect(() => {
        reportsList(sectionTypesEnum.Reports).then((res) => {
            setItems(res);
            setLoading(false);
        });
    }, []);

    const close = () => {
        const { history, back } = props;
        back ? back() : history.push(paths.root);
    };

    return (
        <Transition dir="left" wrapper="page-col--overflow-inherit" {...props}>
            <div className="page-book__list book-list list book-list--nofilter book-list--nopagination">
                <div className="book-list__head-wrap">
                    <div className="book-list__head">
                        <div className="book-list__head-close close close--sm" onClick={close} />
                        <div className="book-list__head-title">Отчеты</div>
                    </div>
                </div>
                <div className={loading ? "list__body-wrap loading" : "list__body-wrap"}>
                    <div className="list__body content-wrapper">
                        <CustomScroll heightRelativeToParent="100%">
                            <div className="container-fluid">
                                {items.map((item, index) => (
                                    <Link
                                        className="d-block reports__item"
                                        key={item.id}
                                        to={paths.reportsShow(item.id)}
                                        name={item.name}
                                    >
                                        {index + 1}. {item.name}
                                    </Link>
                                ))}
                            </div>
                        </CustomScroll>
                    </div>
                </div>
            </div>
        </Transition>
    );
}

export default connect(ReportsList);
